import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    tipoDistribuidor: { label: i18n.t('distributors.tipo_distribuidor'), value: '' },
    tipoProvisionamiento: { label: i18n.t('distributors.tipo_provisionamiento'), value: '' },
  } 
}
const columns = function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
    { field: 'IdDistribuidor', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'Nombre', width: '400px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'NumeroClientes', width: '240px', title: i18n.t('license.num_clients'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'idTipoDistribuidor', width: '400px', title: i18n.t('distributors.tipo_distribuidor'), format: 'TIPOS_DISTRIBUIDOR', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'idTipoProvisionamiento', width: '400px', title: i18n.t('distributors.tipo_provisionamiento'), format: 'TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
  ] 
}
const mystore = parent({ navigate: true, namespaced: true, getTranslateColumns: columns, getTranslateMasterFilters })

export default mystore
